import { TextField } from "@mui/material";

const StdTextField = ({
  formVals,
  name,
  handleFieldChange,
  handleFieldTouch,
  ...rest
}) => {
  const fieldModel = formVals.get(name);
  const label = fieldModel.get("label");
  const helperText = fieldModel.get("err_msg");
  const isError = helperText !== " ";
  const value = fieldModel.get("val_ipt");
  const disabled = fieldModel.get("disabled");
  return (
    <TextField
      label={label}
      variant="filled"
      fullWidth
      error={isError}
      helperText={helperText}
      value={value}
      onChange={(e) => handleFieldChange(name, e.target.value)}
      onBlur={() => handleFieldTouch(name)}
      disabled={disabled}
      {...rest}
    />
  );
};

export default StdTextField;
